import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SellerPerformance {
  seller_id: string;
  seller_name: string;
  business_unit: string | null;
  brand: string;
  total_deals: number;
  total_payments: number;
  valor_total_vendido: number | null;
  valor_creditos_upsell: number | null;
  valor_liquido_vendido: number | null;
  valor_recebido: number;
  taxa_recebimento: number | null;
  taxa_inadimplencia: number | null;
  taxa_cancelamento: number;
  dso_medio: number | null;
}

export function useSellerPerformance(businessUnit?: string, brand?: string) {
  return useQuery({
    queryKey: ['seller-performance', businessUnit, brand],
    queryFn: async () => {
      let query = supabase
        .from('v_seller_performance')
        .select('*')
        .order('total_deals', { ascending: false });

      if (businessUnit && businessUnit !== 'all') {
        query = query.eq('business_unit', businessUnit);
      }
      
      if (brand && brand !== 'all') {
        query = query.eq('brand', brand);
      }

      const { data, error } = await query;
      if (error) throw error;
      return data as SellerPerformance[];
    },
  });
}
